import moment from "moment-timezone";

const REFERENCE_TIMEZONE = 'UTC';

export const getTodayLocalDisplay = () => {
    return moment().format('MMMM D, YYYY');
  };

// Format date with various options
export const formatDate = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  
  const momentDate = moment(date);
  
  if (!momentDate.isValid()) return '';
  
  return momentDate.format(format);
};

export const getTodayLocal = () => {
  return moment().format('YYYY-MM-DD');
};

// Get a date string in YYYY-MM-DD format for a given date (local timezone)
export const getLocalDateString = (date) => {
  return moment(date).format('YYYY-MM-DD');
};

// Get today's date in reference timezone
export const getTodayReference = () => {
  return moment().tz(REFERENCE_TIMEZONE).format('YYYY-MM-DD');
};

// Get yesterday's date in user's local timezone
export const getYesterdayLocal = () => {
  return moment().subtract(1, 'day').format('YYYY-MM-DD');
};

// Get yesterday's date in reference timezone
export const getYesterdayReference = () => {
  return moment().tz(REFERENCE_TIMEZONE).subtract(1, 'day').format('YYYY-MM-DD');
};

// Calculate time remaining until end of day
export const getTimeToEndOfDay = () => {
  const now = moment();
  const endOfDay = moment().endOf('day');
  const duration = moment.duration(endOfDay.diff(now));
  
  if (duration.asHours() > 1) {
    return `${Math.floor(duration.asHours())} hours`;
  } else {
    return `${duration.minutes()} minutes`;
  }
};

// Calculate time remaining until end of day in reference timezone
export const getTimeToEndOfDayReference = () => {
    
  const now = moment().tz(REFERENCE_TIMEZONE);
  
  const endOfDay = moment().tz(REFERENCE_TIMEZONE).endOf('day');
  const duration = moment.duration(endOfDay.diff(now));
  
  if (duration.asHours() > 1) {
    return `${Math.floor(duration.asHours())} hours`;
  } else {
    return `${duration.minutes()} minutes`;
  }
};

// Get detailed time remaining object (for more granular control)
export const getTimeToEndOfDayDetailed = (timezone = 'local') => {
  const now = moment();
  const endOfDay = timezone === 'reference' 
    ? moment().tz(REFERENCE_TIMEZONE).endOf('day')
    : moment().endOf('day');
  const duration = moment.duration(endOfDay.diff(now));
  
  return {
    hours: Math.floor(duration.asHours()),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
    totalMinutes: Math.floor(duration.asMinutes()),
    totalSeconds: Math.floor(duration.asSeconds()),
    formatted: duration.asHours() > 1 
      ? `${Math.floor(duration.asHours())} hours`
      : `${duration.minutes()} minutes`
  };
};
 
